import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { protectedRoutes } from "app/routes";

import GullLayout from "app/layouts/GullLayout";
import AccessDenied from "app/views/sessions/AccessDenied";
import {refreshToken} from "../services/AuthService";
import jwtAuthService from "../services/jwtAuthService";

const userHasPermission = (pathname, user, routes) => {
  if (!user) {
    return false;
  }

  const matched = routes.find((r) => r.path === pathname);
  return matched && matched.auth && matched.auth.length ? matched.auth.includes(user.role) : true;
};

export default function AuthGuard() {

  const { pathname } = useLocation();
  const [previousRoute, setPreviousRoute] = useState(null);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  let hasPermission = userHasPermission(pathname, user, protectedRoutes);

  useEffect(() => {
    if (previousRoute !== null) setPreviousRoute(pathname);
  }, [pathname, previousRoute]);

  const checkJwtAuth = () => {
    jwtAuthService.loginWithToken().then((token) => {

    });
  };

  useEffect(() => {

    const interval = setInterval(() => {
      checkJwtAuth();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isAuthenticated && hasPermission ? (
        <GullLayout>
          <Outlet />
        </GullLayout>
      ) : (
        <>
          {isAuthenticated && !hasPermission ? (
            <AccessDenied />
          ) : (
            <Navigate to={previousRoute || "/sessions/signin"} replace={true} />
          )}
        </>
      )}
    </>
  );
}
